import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { analyticsLogger, PageType } from 'commons/src/analytics';
import { INSIGHT_VIEWED_REPORTS } from 'commons/src/analytics/AnalyticsEvents';
import PageHeader from 'commons/src/components/headers/PageHeader';
import { roleRestrictions } from 'commons/src/constants';
import { userRoleAboveRequiredLevel } from 'commons/src/features/authorization/userRoleAboveRequiredLevel';
import { Role } from 'commons/src/models/commonEnums';
import { paths } from '../../../constants';
import { Store } from '../../../reducers';
import InsightMainTile from './InsightMainTile';

export const InsightMainPageComponent = (): React.ReactElement => {
    const { t: txt } = useTranslation();
    const indoorQualityReport2Enabled = useSelector((store: Store) => store.toggles.indoorQualityReport2Enabled);
    const userRole = useSelector((state: Store) => state.userSettings.selectedGroup?.role || Role.VIEWER);

    useEffect(() => {
        analyticsLogger(INSIGHT_VIEWED_REPORTS, { pageType: PageType.Insight });
    }, []);

    return (
        <div className="radon-insight-view">
            <PageHeader title={txt('Reports.Reports')} />
            <div className="page-wrapper-flex page-wrapper-flex--wrap">
                <InsightMainTile
                    headerText="RadonInsight.RadonMitigation"
                    description="Insight.RadonInsightReportDescription"
                    href={`/${paths.radonInsight}`}
                    type="radon"
                />
                <InsightMainTile
                    headerText="Insight.IaqAnalysis"
                    description="Insight.IaqAnalysisDescription"
                    href={`/${paths.iaqInsight}`}
                    type="iaq"
                />
                {indoorQualityReport2Enabled && (
                    <InsightMainTile
                        headerText="Insight.IaqAnalysis2.0"
                        description="Insight.IaqAnalysisDescription"
                        href={`/${paths.iaqInsight2}`}
                        type="iaq"
                    />
                )}
                <InsightMainTile
                    headerText="VirusInsight.VirusRiskInsight"
                    description="VirusInsight.VirusRiskTileDescription"
                    href={`/${paths.virusRiskInsight}`}
                    type="virusRisk"
                />
                <InsightMainTile
                    headerText="Insight.OutdoorVsIndoor"
                    description="Insight.OutdoorVsIndoorDescription"
                    href={`/${paths.outdoorInsightPage}`}
                    type="outdoorVsIndoor"
                />
                <InsightMainTile
                    headerText="InsightCertificate.IAQCertificate"
                    description="InsightCertificate.CertificateCardDescription"
                    href={`/${paths.iaqCertificate}`}
                    type="iaqCertificate"
                />
                <InsightMainTile
                    headerText="WellReport.WellReport"
                    description="WellReport.WellReportDescription"
                    href={`/${paths.wellReport}`}
                    type="wellReport"
                />
                {userRoleAboveRequiredLevel(userRole, roleRestrictions.createEditEmailSummary) && (
                    <InsightMainTile
                        headerText="EmailSummary.WeeklyBuildingsSummary"
                        description="EmailSummary.ReportsDescription"
                        href={`/${paths.emailSummaryReport}`}
                        type="emailSummary"
                        buttonText="EmailSummary.SetUpEmail"
                    />
                )}
                <InsightMainTile
                    headerText="Calibration.CalibrationReport"
                    description="Calibration.CalibrationDescription"
                    href={`/${paths.calibrationCertificate}`}
                    type="calibration"
                />
            </div>
        </div>
    );
};

export default InsightMainPageComponent;
